import { useCreateEditor } from '@/components/editor/use-create-editor';
import { Editor, EditorContainer } from '@/components/plate-ui/editor';
import type { Value } from 'platejs';
import { Plate } from 'platejs/react';
import type { ClipboardEvent, ComponentProps } from 'react';
import { plateHtmlSerializer } from './htmlSerializer';

type THubertPlateValue = string | Value;

interface Props extends ComponentProps<'div'> {
  value?: THubertPlateValue;
  onValueChange?: (stringValue: string, plateValue: Value) => void;
  isReadOnly?: boolean;
  stripFormattingOnPaste?: boolean;
}

export function PlateEditor({ value, onValueChange, isReadOnly, stripFormattingOnPaste = true }: Props) {
  const editor = useCreateEditor({ value });

  const handlePaste = (event: ClipboardEvent) => {
    if (stripFormattingOnPaste) {
      event.preventDefault();
      event.stopPropagation();
      const text = event.clipboardData.getData('text/plain');
      if (text) {
        editor.tf.insertText(text);
      }
    }
  };

  return (
    <Plate
      editor={editor}
      readOnly={isReadOnly}
      onValueChange={({ value }) => {
        if (onValueChange) {
          const s = plateHtmlSerializer(value);
          onValueChange(s, value);
        }
      }}
    >
      <EditorContainer variant={isReadOnly ? 'comment' : 'select'}>
        <Editor variant={isReadOnly ? 'comment' : 'default'} placeholder="Type something..." onPaste={handlePaste} />
      </EditorContainer>
    </Plate>
  );
}
